// Login.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API from '../api';
import TurnstileWidget from '../components/TurnstileWidget';
import { getDeviceType, getDeviceUUID } from '../utils/deviceManager';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [error, setError] = useState('');
  const [deviceError, setDeviceError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Nettoyer les tokens expirés au chargement de la page
  useEffect(() => {
    // Supprimer les tokens au chargement de la page de login pour éviter les problèmes
    localStorage.removeItem('token');
    localStorage.removeItem('adminToken');
    
    // Détecter et afficher les messages d'erreur d'authentification
    const authError = localStorage.getItem('authError');
    if (authError) {
      setError(authError);
      // Supprimer le message après l'avoir affiché
      localStorage.removeItem('authError');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setDeviceError('');
    setIsLoading(true);
    
    if (!turnstileToken) {
      setError('Veuillez compléter la vérification Turnstile.');
      setIsLoading(false);
      return;
    }

    try {
      const response = await API.post('/api/auth/login', 
        new URLSearchParams({
          username: email,
          password: password
        }), 
        {
          headers: {
            'X-Turnstile-Token': turnstileToken,
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      
      localStorage.setItem('token', response.data.access_token);
      setIsLoading(false);
      navigate('/dashboard');
    } catch (err) {
      // Reset Turnstile — tokens are single-use, user must re-validate
      if (window.turnstile?.reset) window.turnstile.reset();
      setTurnstileToken(null);
      setIsLoading(false);

      if (err.response?.status === 403 && err.response?.data?.detail?.includes('appareil')) {
        setDeviceError(err.response.data.detail);
      } else {
        const errorMsg = err.response?.data?.detail || 'Erreur lors de la connexion.';
        setError(errorMsg);
      }
    }
  };

  return (
    <div className="login-container">
      <h2>Connexion</h2>
      
      {/* Section "Première connexion" mise en évidence */}
      <div className="first-login-container">
        <p className="first-login-text">Première connexion ? <Link to="/register">Inscription</Link></p>
      </div>
      
      {error && <p className="error">{error}</p>}
      {deviceError && (
        <div className="device-error-box">
          <p className="error">{deviceError}</p>
          <p>Pour des raisons de sécurité, votre licence ne peut être utilisée que sur un seul appareil de chaque type (un ordinateur ET un smartphone).</p>
        </div>
      )}
      
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <div className="turnstile">
          <TurnstileWidget onVerify={setTurnstileToken} />
        </div>
        <button 
          type="submit" 
          disabled={isLoading} 
          className={isLoading ? "loading-button" : ""}
        >
          {isLoading ? "Connexion en cours..." : "Se connecter"}
        </button>
      </form>
      
      <div className="links">
        <p>Mot de passe perdu ? <Link to="/forgot-password">Réinitialiser</Link></p>
      </div>
    </div>
  );
}

export default Login;
